// Brand mark per docs/Veft/brand.md §4 — lowercase Source Serif 4 italic 600
// in forest. The italic *is* the brand; do not outline, box, or pair with a
// locked-up tagline.
export function Wordmark({ size = 22, color = "var(--forest)" }) {
  return (
    <span
      style={{
        fontFamily: 'var(--font-serif)',
        fontStyle: "italic",
        fontWeight: 600,
        fontSize: size,
        letterSpacing: "-0.02em",
        color,
        lineHeight: 1,
        userSelect: "none",
      }}
    >
      veft
    </span>
  );
}
